import React from 'react'
import { translatable } from 'react-instantsearch-core'
import Button from '@bit/atd.web.button'

type ItemsPops = {}[]

type PropTypes = {
  items: ItemsPops
  canRefine: boolean
  refine: (items: any) => void
  translate: (key: string, ...params: any[]) => string
}

const ClearFilters = (props: PropTypes) => {
  const { items, canRefine, refine, translate } = props

  return (
    canRefine && (
      <div>
        <Button
          onClick={(e) => {
            e && e.preventDefault()
            refine(items)
          }}
          variant="primary"
        >
          {translate('reset')}
        </Button>
      </div>
    )
  )
}

export default translatable({
  reset: 'Clear All Filters',
  // @ts-ignore
})(ClearFilters)
